export enum OrganisationTypes {
    RAndD = 10,
    University = 20,
    Other = 30,
    Funders = 40,
    Legislators = 50,
    Government = 60,
    NonProfit = 70,
    Membership = 80,
    NoLongerOperating = 90,
}

export const organisationTypeValues = {
    [OrganisationTypes.RAndD]: 'R&D Active Business',
    [OrganisationTypes.University]: 'University, Research Institute or RTO',
    [OrganisationTypes.Other]:
        'Other (for profit) Business - e.g. Consultants or Professional Services',
    [OrganisationTypes.Funders]: 'Funders, Investors, Incubators and Accelerators',
    [OrganisationTypes.Legislators]: 'Legislators/Policy Makers ',
    [OrganisationTypes.Government]: 'Government or Public Body',
    [OrganisationTypes.NonProfit]: 'Charity or Not-for-profit',
    [OrganisationTypes.Membership]:
        'Membership Organisation (Trade or Professional Body or Learned Society)',
    [OrganisationTypes.NoLongerOperating]: 'No Longer Operating',
};

export enum OrganisationSize {
    micro = 10,
    small = 20,
    medium = 30,
    large = 40,
}

export const organisationSizeValues = {
    [OrganisationSize.micro]: 'Micro (0-9 employees)',
    [OrganisationSize.small]: 'Small (10-49 employees)',
    [OrganisationSize.medium]: 'Medium (50-249 employees)',
    [OrganisationSize.large]: 'Large (>250 employees)',
};
